import { useCallback, useEffect, useState } from 'react';

const DEFAULT_COOLDOWN_SECONDS = 30;

/**
 * 쿨다운 카운트다운 타이머 훅
 * - startCooldown()을 호출하면 쿨다운 시작
 * - 1초마다 카운트다운
 */
export const useCooldownTimer = (seconds = DEFAULT_COOLDOWN_SECONDS) => {
  const [cooldownSeconds, setCooldownSeconds] = useState(0);

  const isCooldownActive = cooldownSeconds > 0;

  const startCooldown = useCallback(() => {
    setCooldownSeconds(seconds);
  }, [seconds]);

  useEffect(() => {
    if (!isCooldownActive) return;

    const timer = setInterval(() => {
      setCooldownSeconds(prev => {
        if (prev <= 1) {
          clearInterval(timer);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [isCooldownActive]);

  return {
    cooldownSeconds,
    isCooldownActive,
    startCooldown,
  };
};
